import React from 'react';
import KybConfirmation from '../KybConfirmation';
import KycForm from '../KycForm/FormWrapper';
import { FieldError } from '../VgsInput/field';
import { BUSINESS_STRUCTURES_THAT_REQUIRE_OWNERS } from '../../const';
import { BeneficialOwnerData } from '../BeneficialOwners';

export default function ConfirmationPage({
  kyb,
  submittedOnYourBehalf,
  onRevealSuccess,
  onRevealFail,
  onValidChange,
  onAddressRegionChange,
  onTitleChange,
  onIsOwnerChange,
  onPercentOwnershipChange,
  form,
  token,
  raiseConfig,
  fieldErrors,
  setRefreshKyb,
  onBeneficialOwnersChange,
  showSubmitForReviewButton,
}: {
  kyb: Kyb;
  submittedOnYourBehalf: boolean;
  form: VGSForm<{ kycId: string }>;
  onRevealSuccess: () => void;
  onRevealFail: () => void;
  onAddressRegionChange: (region: string) => void;
  onTitleChange: (title: string) => void;
  onIsOwnerChange: (isOwner: boolean) => void;
  onPercentOwnershipChange: (percentOwnership: number) => void;
  onValidChange: (isValid: boolean) => void;
  token: string;
  raiseConfig?: {
    raiseCampaignId?: string;
    raiseUserId?: string;
  };
  fieldErrors: FieldError[];
  setRefreshKyb: (refresh: symbol) => void;
  onBeneficialOwnersChange: (
    beneficialOwnersData: BeneficialOwnerData[],
  ) => void;
  showSubmitForReviewButton?: boolean;
}): React.JSX.Element {
  const askIsOwner = BUSINESS_STRUCTURES_THAT_REQUIRE_OWNERS.includes(
    kyb.structure,
  );
  return (
    <div className='min-h-screen flex justify-center'>
      <div className='w-full'>
        <KybConfirmation
          kyb={kyb}
          onRevealSuccess={onRevealSuccess}
          onRevealFail={onRevealFail}
          submittedOnYourBehalf={submittedOnYourBehalf}
          token={token}
          raiseConfig={raiseConfig}
          setRefreshKyb={setRefreshKyb}
          allowPhoneNumberUpdate={showSubmitForReviewButton}
        />
        <hr />
        {showSubmitForReviewButton && (
          <KycForm
            form={form}
            askIsOwner={askIsOwner}
            onAddressRegionChange={onAddressRegionChange}
            onTitleChange={onTitleChange}
            onIsOwnerChange={onIsOwnerChange}
            onPercentOwnershipChange={onPercentOwnershipChange}
            onValidChange={onValidChange}
            fieldErrors={fieldErrors}
            entityName='representative'
            onBeneficialOwnersChange={onBeneficialOwnersChange}
          />
        )}
      </div>
    </div>
  );
}
